module.exports = __webpack_public_path__ + "img/xici-black.b40f6e8f.svg";